import { createApp } from "vue";
import ComponentTechnicalData from "./Component-Technical-data.vue";

const app = createApp({
  components: {
    "tecnical-data-component": ComponentTechnicalData,

  },
}).mount("#container-tecnical-data");
